var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('extra-format-selector-dialog',{directives:[{name:"loading",rawName:"v-loading.fullscreen.lock",value:(_vm.isLoading),expression:"isLoading",modifiers:{"fullscreen":true,"lock":true}}],ref:"selector"})}
var staticRenderFns = []

export { render, staticRenderFns }